<div
  [class.error]="hasError()"
  [formGroup]="form"
  [ngStyle]="containerStyles"
  class="connection-selector"
>
  <!-- Connector selector info -->
  <div class="connection" [class.connected]="isConnected()">
    <mat-icon
      [hidden]="!isConnectorIconVisible()"
      class="connection-icon"
      svgIcon="{{ connectorIcon() }}"
    />

    @if (!availableCalendars()) {
      <div class="connection-name" blazeTooltip="{{ label() }}">{{ label() }}</div>
    }

    <!-- Google Calendar selector -->
    @if (isGoogleCalendarSelector() && availableCalendars()) {
      <blaze-select
        [allowNone]="false"
        [options]="availableCalendars() ?? []"
        [showNoneOption]="false"
        [showSelection]="true"
        class="calendar-select"
        filterPlaceholder="Select calendar"
        formControlName="calendarId"
      />

      <div class="connection-actions">
        <button
          (click)="onConnectGoogleCalendar()"
          [class.disabled]="!form.value.calendarId"
          [disabled]="!form.value.calendarId"
          [ngStyle]="primaryButtonStyles"
          class="bd-btn bd-btn-primary disconnect-connection"
        >
          <span>Done</span>
        </button>
      </div>
    }

    <!-- Connection actions -->
    @if (!availableCalendars()) {
      <div class="connection-actions">
        @if (isConnected() && isEditable()) {
          <mat-icon
            (click)="onEditConnection()"
            [ngStyle]="secondaryButtonStyles"
            class="edit-icon bd-btn-icon"
            svgIcon="icon_edit_24"
          />
        }

        @if (!isConnected() && !availableCalendars()) {
          <button
            (click)="onConnect()"
            [blazeTooltip]="buttonTooltip()"
            [disabled]="isButtonDisabled()"
            [ngStyle]="primaryButtonStyles"
            class="bd-btn bd-btn-primary disconnect-connection"
            matTooltipPosition="right"
          >
            <span>Connect</span>
          </button>
        } @else if (isConnected()) {
          <button
            (click)="onRemoveConnection()"
            [disabled]="isButtonDisabled()"
            [ngStyle]="secondaryButtonStyles"
            class="bd-btn bd-btn-accent disconnect-connection"
          >
            <span>Disconnect</span>
          </button>
        }
      </div>
    }
  </div>
</div>

<!-- Connecting error message -->
@if (hasError()) {
  <div class="message text-warn">
    Configuration connection error. Please try connecting again.
  </div>
}
